import { Injectable } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * declare Jquery
 * */
declare let $: any;

@Injectable({ providedIn: 'root' })
export class ThemeService {
  theme: string = '';
  cssContent: string = '';
  variableFields: any = {};
  isMenuFolded = false;
  isSideNavDark = false;
  headerColor = 'default';
  constructor(
    private localStorageService: LocalStorageService,
  ) {
    // $.get(`/assets/scss/_variables_theme.scss`, (cssContent) => {
    //   this.cssContent = cssContent.split(':root {')[1];
    //   const variableFields = this.cssContent.split('}')[0].split(';');
    //   variableFields.forEach((field) => {
    //     const text = field.replace(' ', '').replace('\r\n', '').replace(`   --`, '').split(':');
    //     if (!text[0] || !text[1]) { 
    //       return;
    //     }
    //     this.variableFields[text[0]] = text[1].replace(' ', '');
    //   })
    //   this.localStorageService.store('variable_theme', this.variableFields);
    //   this.changeTheme(this.localStorageService.retrieve('theme'));
    // });
  }
  
  changeTheme(theme) {
    theme = theme || 'default';
    if (this.theme) {
      $('body').removeClass(this.theme + '-theme');
      this.theme = theme;
    }
    this.theme = theme;
    $('body').addClass(this.theme + '-theme');
    
    if (theme === 'dynamic') {
      let mainColor = '', color1 = '', color2 = '';
      this.variableFields[`${'dynamic-theme-main-color'}`] = this.localStorageService.retrieve('dynamic-theme-main-color') || this.variableFields[`${'dynamic-theme-main-color'}`];
      this.variableFields[`${'dynamic-theme-color'}`] = this.localStorageService.retrieve('dynamic-theme-color') || this.variableFields[`${'dynamic-theme-color'}`];
      this.variableFields[`${'dynamic-theme-color-2'}`] = this.localStorageService.retrieve('dynamic-theme-color-2') || this.variableFields[`${'dynamic-theme-color-2'}`];
      this.variableFields[`${'dynamic-theme-color-3'}`] = this.localStorageService.retrieve('dynamic-theme-color-3') || this.variableFields[`${'dynamic-theme-color-3'}`];
      this.variableFields[`${'dynamic-theme-color-4'}`] = this.localStorageService.retrieve('dynamic-theme-color-4') || this.variableFields[`${'dynamic-theme-color-4'}`];
      this.variableFields[`${'dynamic-theme-color-5'}`] = this.localStorageService.retrieve('dynamic-theme-color-5') || this.variableFields[`${'dynamic-theme-color-5'}`];
      document.documentElement.style.setProperty(`--dynamic-theme-main-color`, this.variableFields[`${'dynamic-theme-main-color'}`]);
      document.documentElement.style.setProperty(`--dynamic-theme-color`, this.variableFields[`${'dynamic-theme-color'}`]);
      document.documentElement.style.setProperty(`--dynamic-theme-color-2`, this.variableFields[`${'dynamic-theme-color-2'}`]);
      document.documentElement.style.setProperty(`--dynamic-theme-color-3`, this.variableFields[`${'dynamic-theme-color-3'}`]);
      document.documentElement.style.setProperty(`--dynamic-theme-color-4`, this.variableFields[`${'dynamic-theme-color-4'}`]);
      document.documentElement.style.setProperty(`--dynamic-theme-color-5`, this.variableFields[`${'dynamic-theme-color-5'}`]);
    }
  }
  private isMenuFoldedActived = new BehaviorSubject<boolean>(this.isMenuFolded);
  isMenuFoldedChanges: Observable<boolean> = this.isMenuFoldedActived.asObservable();

  private isSideNavDarkActived = new BehaviorSubject<boolean>(this.isSideNavDark);
  isSideNavDarkChanges: Observable<boolean> = this.isSideNavDarkActived.asObservable();

  private isExpandActived = new BehaviorSubject<boolean>(false);
  isExpandChanges: Observable<boolean> = this.isExpandActived.asObservable();

  private currentHeaderColor = new BehaviorSubject(this.headerColor);
  selectedHeaderColor = this.currentHeaderColor.asObservable();
  toggleFold(isFolded: boolean) {
    this.isMenuFoldedActived.next(isFolded);
  }

  toogleSideNavDark(isDark: boolean) {
      this.isSideNavDarkActived.next(isDark);
  }

  toggleExpand(isExpand: boolean) {
      this.isExpandActived.next(isExpand);
  }

  changeHeaderColor(color: string) {
      this.currentHeaderColor.next(color);
  }
}